import React, {
  memo,
  useCallback,
  useEffect,
  useLayoutEffect,
  useRef,
} from 'react'
import { Image, Transformer } from 'react-konva'
import useImage from 'use-image'

const RectangleBox = ({
  shapeProps,
  isSelected,
  onChange,
  urlImg,
  scale = 1,
}) => {
  const [image] = useImage(urlImg)
  const shapeRef = useRef(null)
  const trRef = useRef(null)

  useEffect(() => {
    if (isSelected && trRef.current && shapeRef.current) {
      trRef.current.setNode(shapeRef.current)
      trRef.current.getLayer().batchDraw()
    }
  }, [isSelected])

  useLayoutEffect(() => {
    if (shapeRef.current) {
      shapeRef.current.cache()
    }
  }, [shapeProps, image, isSelected])

  const handleDragEnd = useCallback(
    e => {
      onChange({
        ...shapeProps,
        x: e.target.x() / scale,
        y: e.target.y() / scale,
      })
    },
    [onChange, shapeProps, scale]
  )

  const handleTransformEnd = useCallback(() => {
    const node = shapeRef.current
    const scaleX = node.scaleX()
    const scaleY = node.scaleY()
    node.scaleX(1)
    node.scaleY(1)
    onChange({
      ...shapeProps,
      x: node.x() / scale,
      y: node.y() / scale,
      width: Math.max(5, node.width() * scaleX) / scale,
      height: Math.max(5, node.height() * scaleY) / scale,
    })
  }, [onChange, shapeProps, scale])

  return (
    <>
      <Image
        image={image}
        ref={shapeRef}
        {...shapeProps}
        x={shapeProps.x * scale}
        y={shapeProps.y * scale}
        width={shapeProps.width * scale}
        height={shapeProps.height * scale}
        draggable
        onDragEnd={handleDragEnd}
        onTransformEnd={handleTransformEnd}
        opacity={0.8}
      />
      {isSelected && (
        <Transformer
          enabledAnchors={[
            'top-left',
            'top-right',
            'bottom-left',
            'bottom-right',
          ]}
          rotateEnabled={false}
          anchorSize={7}
          ref={trRef}
          boundBoxFunc={(oldBox, newBox) => {
            if (newBox.width < 5 || newBox.height < 5) {
              return oldBox
            }
            return newBox
          }}
        />
      )}
    </>
  )
}

export default memo(RectangleBox)
